module.exports = __webpack_public_path__ + "static/media/Boost (BIAS Preamp) VR.a1507a9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedal/Boost (BIAS Preamp) VR.mp3
// module id = wHu1
// module chunks = 12